import fetch from "auth/FetchInterceptor";

const AuthService = {};

AuthService.login = function (store_id, email, password) {
  return fetch({
    url: "/jwt/create/",
    method: "post",
    data: { store_id, email, password },
  });
};

AuthService.register = function (data) {
  return fetch({
    url: "/register/",
    method: "post",
    data: data,
  });
};

AuthService.updateProfile = function (data) {
  return fetch({
    url: "/user/",
    method: "put",
    data: data,
  });
};

AuthService.changePassword = function (data) {
  return fetch({
    url: "https://api.hamilton-shop.online/api/users/set_password/",
    method: "post",
    data: data,
  });
};

AuthService.getProfile = function () {
  return fetch({
    url: "/user/",
    method: "get",
  });
};

export default AuthService;
